module.exports = __webpack_public_path__ + "static/media/wsrc_logo.00134614.jpg";